import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PersonalInfoSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="User" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Personal Information</h3>
            <p className="text-sm text-muted-foreground">Pre-filled from your profile</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Full Name"
          type="text"
          name="fullName"
          value={formData?.fullName}
          onChange={handleInputChange}
          placeholder="Enter your full name"
          required
          error={errors?.fullName}
        />

        <Input
          label="Email Address"
          type="email"
          name="email"
          value={formData?.email}
          onChange={handleInputChange}
          placeholder="your.email@example.com"
          required
          error={errors?.email}
        />

        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          value={formData?.phone}
          onChange={handleInputChange}
          placeholder="+91 98765 43210"
          description="Optional"
          error={errors?.phone}
        />

        <Input
          label="Current Location"
          type="text"
          name="location"
          value={formData?.location}
          onChange={handleInputChange}
          placeholder="City, State"
          required
          error={errors?.location}
        />

        <Input
          label="LinkedIn Profile"
          type="url"
          name="linkedin"
          value={formData?.linkedin}
          onChange={handleInputChange}
          placeholder="https://linkedin.com/in/yourprofile"
          description="Optional but recommended"
        />

        <Input
          label="Portfolio Website"
          type="url"
          name="portfolio"
          value={formData?.portfolio}
          onChange={handleInputChange}
          placeholder="https://yourportfolio.com"
          description="Optional"
        />
      </div>
    </div>
  );
};

export default PersonalInfoSection;